import { render, staticRenderFns } from "./TransactionRecordManagement.vue?vue&type=template&id=50365a84&scoped=true"
import script from "./TransactionRecordManagement.vue?vue&type=script&lang=js"
export * from "./TransactionRecordManagement.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecordManagement.vue?vue&type=style&index=0&id=50365a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50365a84",
  null
  
)

export default component.exports